export default "__VITE_ASSET__52e506fc__"